import { apiService } from "../utils/apiService";

const ensureArray = (data) => {
  if (Array.isArray(data)) return data;
  return [];
};

const mapSavedBreakdownCategory = ({
  id,
  categoryId,
  categoryName,
  subCategoryId,
  subCategoryName,
  componentId,
  componentName,
  causeId,
  causeName,
  freeTextCat,
  freeTextSubCat,
  tyrePosition,
}) => ({
  id,
  categoryId,
  category: categoryName,
  subcategoryId: subCategoryId,
  subcategory: subCategoryName,
  componentId,
  component: componentName,
  causeId,
  causeName,
  freeTextCat,
  freeTextSubCat,
  tyrePosition,
});

const mapCategory = ({ id, category, active }) => ({ id, category, active });

const mapSubCategory = ({ id, categoryId, subCategory, active }) => ({
  id,
  categoryId,
  subCategory,
  active,
});

const mapComponent = ({ id, subCategoryId, component, active }) => ({
  id,
  subCategoryId,
  component,
  active,
});

const mapCause = ({ id, cause, active }) => ({ id, cause, active });

const mapCategorySearchResult = ({
  categoryId,
  categoryName,
  subCategoryId,
  subCategoryName,
  componentId,
  componentName,
}) => ({
  categoryId,
  categoryName,
  subCategoryId,
  subCategoryName,
  componentId,
  componentName,
});

const breakdownCategoryService = {
  getCategories: async () => {
    const data = await apiService.get("/Settings/GetBreakdownCategories");
    return ensureArray(data).map(mapCategory);
  },

  getSubCategories: async (categoryId) => {
    if (!categoryId) return [];
    const data = await apiService.get(`/Settings/GetBreakdownSubCategories/${categoryId}`);
    return ensureArray(data).map(mapSubCategory);
  },

  getComponents: async (subCategoryId) => {
    if (!subCategoryId) return [];
    const data = await apiService.get(`/Settings/GetBreakdownComponents/${subCategoryId}`);
    return ensureArray(data).map(mapComponent);
  },

  getCauses: async () => {
    const data = await apiService.get("/Settings/GetBreakdownCauses");
    return ensureArray(data).map(mapCause);
  },

  searchCategoryCombinations: async ({ searchTerm, pageNumber = 1, tyres = false }) => {
    const term = String(searchTerm || "").trim();
    if (!term) return [];

    const data = await apiService.get("/BreakdownCategory/GetCategoryAndSubCategorySearch", {
      params: {
        searchTerm: term,
        pageNumber,
        tyres,
      },
    });

    return ensureArray(data).map(mapCategorySearchResult);
  },

  getBreakdownCategories: async (breakdownId) => {
    if (!breakdownId) return [];
    const data = await apiService.get(`/Events/Breakdowns/GetBreakdownCategoryByBreakdownId/${breakdownId}`);
    return ensureArray(data).map(mapSavedBreakdownCategory);
  },

  insertBreakdownCategory: (payload) =>
    apiService.post("/Events/Breakdowns/V2InsertBreakdownCategory", payload),

  deleteBreakdownCategory: (categoryRowId) =>
    apiService.delete(`/Events/Breakdowns/V2DeleteBreakdownCategory/${categoryRowId}`),
};

export default breakdownCategoryService;
